import script from "./DateRangePickerQuick.vue?vue&type=script&lang=ts&setup=true"
export * from "./DateRangePickerQuick.vue?vue&type=script&lang=ts&setup=true"

import "./DateRangePickerQuick.vue?vue&type=style&index=0&id=5c220c5a&lang=scss&scoped=true"

import exportComponent from "/builds/intranet/intranet/vue/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c220c5a"]])

export default __exports__